module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-unknown-19596e0c6e0fd000cd1c3b8be0be5504.svg";